import * as type from '../types';

const initialState = {
    selectedOrganization: {},
    selectedUser: {},
    filteredOperationType: '',
    filteredImportance: '',
    filteredSubject: '',
    list: [],
    activePage: 0,
    totalPageCount: 0,
    loading: false,
    error: false
}

const operationHistory = (state = initialState, action) => {
    switch(action.type){
        case type.SET_OPERATION_HISTORY_SELECTED_ORGANIZATION:
            return {
                ...state,
                selectedOrganization: action.payload
            }
        case type.SET_OPERATION_HISTORY_SELECTED_USER:
            return {
                ...state,
                selectedUser: action.payload
            }
        case type.SET_FILTERED_OPERATION_TYPE:
            return {
                ...state,
                filteredOperationType: action.payload
            }
        case type.SET_FILTERED_IMPORTANCE:
            return {
                ...state,
                filteredImportance: action.payload
            }
        case type.SET_FILTERED_SUBJECT:
            return {
                ...state,
                filteredSubject: action.payload
            }
        case type.GET_OPERATION_HISTORY_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                error: false
            }
        case type.GET_OPERATION_HISTORY_LIST_SUCCEEDED:
            return {
                ...state,
                list: action.payload.items,
                activePage: action.payload.activePage,
                totalPageCount: action.payload.totalPageCount,
                loading: false,
                error: false
            }
        case type.GET_OPERATION_HISTORY_LIST_FAILED:
            return {
                ...state,
                loading: false,
                error: true
            }
        default:
            return state;
    }
}

export default operationHistory;

